import { styled } from "styled-components";
import { InputStyledProps } from "./types";

export const InputStyled = styled.div<InputStyledProps>`
  display: flex;
  flex-direction: column;
  position: relative !important;
  width: 100% !important;

  & > label {
    margin-bottom: 6px;
    font-size: 11px !important;
    color: #000 !important;
    font-weight: 700 !important;
    line-height: 160%;
    @media (max-width: 750px) {
      display: none;
    }
  }
  & > input {
    height: 45px !important;
    min-width: 200px !important;
    width: 100% !important;
    background-color: #ffffff !important;
    border: 1px solid #000 !important;
    box-shadow: 1px 1px 2px rgba(16, 24, 40, 0.12);
    border-radius: 8px;
    outline: none !important;
    padding: 0 12px;
    color: ${({ color }) => color || "#000000"} !important;
    font-size: ${({ fontSize }) => fontSize || "16px"} !important;
    font-weight: ${({ fontWeight }) => fontWeight || 600} !important;
    @media (max-width: 980px) {
      height: 40px !important;
    }
  }
  & > svg {
    position: absolute !important;
    bottom: 14px;
    right: 12px;
    font-size: 14px !important;
    color: ${({ spanError }) => (spanError ? "#b91c1c" : "#000000")}!important;
    font-weight: 500 !important;
    line-height: normal !important;
  }
  @media (max-width: 980px) {
    font-size: 13px !important;
  }
`;
